// extracted by mini-css-extract-plugin
export default {"Section":"Section_Section__PObfM","FullScreen":"Section_FullScreen__z-58e"};